import '@vfde-brix/overlay/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';

import {
    fetchOverlayContent,
    getLinksThatShouldOpenInAnOverlay,
} from './overlay-service';

const linksThatShouldOpenInAnOverlay = getLinksThatShouldOpenInAnOverlay();

for (const linkThatShouldOpenInAnOverlay of linksThatShouldOpenInAnOverlay) {
    linkThatShouldOpenInAnOverlay.addEventListener('click', event=> {
        // Don't follow the link
        event.preventDefault();

        fetchOverlayContent(event.target.getAttribute('href'));
    }, false);
}
